<template>
  <GModal v-if="showModal" class="custom-modal modal--product-existed" :noscroll="true">
    <div slot="header">
      <button type="button" class="close" aria-label="Close">
        <img src="/assets/img/icons/close-modal.svg" alt="SOCO" @click.prevent="close" />
      </button>
      <h2 class="modal-heading">PRODUCT EXISTED</h2>
    </div>
    <div slot="body">
      <p class="modal-text">Produk ini tidak dapat ditambahkan karena telah tersedia di database kami.</p>
      <div class="product-info">
        <div class="product-info__thumb">
          <img :src="product.images[0].url" class="product-info__img" />
        </div>
        <div class="product-info__content">
          <h5 class="product-info__brand-name">{{ product.brand.name }}</h5>
          <p class="product-info__product-name">{{ product.name }}</p>
        </div>
      </div>

      <a :href="productUrl(product)" target="_blank" rel="noopener" class="btn red btn-shop-now btn-block">
        Shop now
      </a>
    </div>
  </GModal>
</template>

<script>
export default {
  name: 'modal-product-existed',
  computed: {
    showModal() {
      return this.$store.state.modal.isModalShow.productExisted;
    },
    product() {
      return this.$store.state.modal.productExisted.data;
    },
  },
  methods: {
    close() {
      this.$store.commit('toggleModalGlobalState', {
        modalName: 'productExisted',
      });
    },
    productUrl(item) {
      let productLink = this.$options.filters.productLinkV3(item);
      if (
        item.default_combination &&
        item.default_combination.attributes &&
        !item.default_combination.attributes.non_specify
      ) {
        const { attributes } = item.default_combination;
        const keys = Object.keys(attributes || {});
        if (keys.length && keys[0] && attributes[keys[0]] && attributes[keys[0]]['name']) {
          productLink += '?';
          keys.forEach(
            (key, idx) =>
              (productLink += `${key}=${this.$options.filters.slug(attributes[key]['name'], '_')}${
                idx < keys.length - 1 ? '&' : ''
              }`)
          );
        }
      }
      return productLink;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal--product-existed ::v-deep {
  .modal-dialog {
    width: 305px;
    height: 244px;
    border-radius: 4px;
    box-shadow: 1px 2px 14px 0px rgba(#231f20, 0.24);
  }

  .modal-body {
    padding-top: 0;
  }

  .modal-header {
    padding: 16px 16px 20px 16px;
    .close {
      margin: 0;
      top: 13px;
      right: 16px;
    }
  }

  .modal-heading {
    font: 13px/18px 'lato-bold', sans-serif;
    letter-spacing: 2px;
    color: #231f20;
    margin: 0;
  }

  .modal-text {
    font: 12.5px/20px 'lato-regular', sans-serif;
    margin: 0 0 24px 0;
    color: #231f20;
  }

  .product-info {
    margin-bottom: 18px;
    min-height: 60px;
    &:before,
    &:after {
      content: ' ';
      display: table;
    }
  }

  .product-info__img {
    height: 60px;
    width: 60px;
  }

  .product-info__thumb {
    float: left;
    width: 60px;
  }

  .product-info__content {
    padding-left: 68px;
  }

  .product-info__brand-name {
    font: 12px/14px 'lato-bold', sans-serif;
    letter-spacing: 1px;
    color: #231f20;
    text-transform: uppercase;
    margin: 0 0 4px 0;
  }

  .product-info__product-name {
    font: 15px/18px 'lato-light';
    margin: 0;
    color: #231f20;
  }
}
</style>
